/* Dansk katalog for locale-closing-focused-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('da', {
  'clo.focus.finalConfirmation': 'Jeg har kontrolleret grundlaget, egenkapitalbegivenheder, efterfølgende begivenheder og fortsat drift. Alle nødvendige posteringer og vurderinger er afklaret. Jeg godkender, at året afsluttes. Godkender og tidspunkt gemmes i historikken.',
  'clo.focus.approve': 'Godkend',
  'clo.focus.startYear': 'Startår for regnskabet',
  'clo.focus.bankSetupMissing': 'Registrer startdato og dokumenteret startsaldo i kontoopsætningen nedenfor. Skriv 0, hvis saldoen var nul.',
  'clo.focus.bankStatements': 'Kontoudtog mangler for perioderne',
  'clo.focus.bankUnsettled': 'Perioder skal afstemmes',
  'clo.focus.bankDifferences': 'Saldoafvigelser skal afklares i bankafstemningen.',
  'clo.focus.bankUnconfigured': 'Opret bankkonto med den rigtige regnskabskonto for disse bogførte saldi',
  'clo.focus.reconcile': 'Fuldfør afstemning',
  'clo.focus.restore': 'Gendan størrelse',
  'clo.focus.fullscreen': 'Fuld skærm',
  'clo.focus.notCalculated': 'Ikke beregnet',
  'clo.focus.taxScope': 'Afklar skatteregime',
  'clo.focus.rateHelp': 'Almindelig norsk selskabsskat er 22 % fra 2019. Bekræft skatteregimet, før beregningen kan godkendes. Finansskat og særregimer kræver særskilt vurdering.',
  'clo.focus.industry': 'Skatteregime',
  'clo.focus.ordinary': 'Almindeligt skatteregime',
  'clo.focus.special': 'Særregime – kræver vurdering',
  'clo.focus.finance': 'Finansskattepligtig',
  'clo.focus.priorLoss': 'Fremførbart underskud fra tidligere år (bekræft også 0)',
  'clo.focus.updateCalculation': 'Gem og beregn',
  'clo.focus.taxCalculation': 'Sådan beregnes skatten',
  'clo.focus.resultBeforeTax': 'Resultat før skat',
  'clo.focus.permanent': '+ Permanente forskelle (netto)',
  'clo.focus.temporaryChange': '− Ændring i midlertidige forskelle',
  'clo.focus.lossApplied': '− Anvendt fremførbart underskud',
  'clo.focus.taxable': '= Skattegrundlag',
  'clo.focus.rate': 'Skattesats',
  'clo.focus.resolveRate': 'Afklar skatteregime ovenfor',
  'clo.focus.payable': '= Betalbar skat',
  'clo.focus.lossRemaining': 'Underskud til fremførsel',
  'clo.focus.deferredTax': 'Udskudt skat / skatteaktiv',
  'clo.focus.temporary': 'Midlertidige forskelle',
  'clo.focus.unrecognized': 'Ikke indregnet skatteaktiv (grundlag)',
  'clo.focus.deferredBasis': 'Grundlag for udskudt skat',
  'clo.focus.deferredAmount': 'Udskudt skat / skatteaktiv',
  'clo.focus.postingApproval': 'Godkend beregning og slutpostering',
  'clo.focus.postingHelp': 'Godkendelsen bekræfter, at du har kontrolleret skattegrundlag, forskelle og fremførbart underskud. Betalbar skat og eventuel ændring i udskudt skat bogføres ved afslutningen af regnskabsåret. Allerede bogførte beløb tages i betragtning af slutposteringen.',
  'clo.focus.postingAccounts': 'Beregnet betalbar skat: debet 8300 / kredit 2500',
  'clo.focus.reviewRequired': 'Skatteregime eller særlige skatteforhold skal afklares før godkendelse.',
  'clo.focus.unsaved': 'Gem og beregn efter ændringer, før du godkender.',
  'clo.focus.editDifferences': 'Rediger forskelle og specifikationer',
  'clo.checklist.custom.mappedDetail': 'Ingen konti mangler kobling til Plummes standardkontoplan. Importerede konti kontrolleres, når de indgår i kontoplanen. Dette er ikke en kontrol af hele skattemelding-koblingen.',
  'clo.priorYear.closedDetail': 'Regnskabsåret {{year}} er afsluttet.',
  'clo.priorYear.noActivity': 'Der er ikke registreret regnskabstal for {{year}} i Plumme. Startåret alene afgør ikke, om forrige år skal afsluttes.',
});
